import React from "react"

import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

interface NumberFieldProps {
  id: string
  label: React.ReactNode
  value: number | string
  /** The raw text typed; each field parses and clamps it in its own way. */
  onChange: (raw: string) => void
  step?: string
  min?: string
  max?: string
  placeholder?: string
  /** Shown after the box, e.g. "£/kWh". Without one the box stands on its own line. */
  unit?: string
  hint?: React.ReactNode
  className?: string
  labelClassName?: string
  inputClassName?: string
}

const NumberField: React.FC<NumberFieldProps> = ({
  id,
  label,
  value,
  onChange,
  step,
  min,
  max,
  placeholder,
  unit,
  hint,
  className,
  labelClassName,
  inputClassName,
}) => {
  const input = (
    <Input
      id={id}
      type="number"
      step={step}
      min={min}
      max={max}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={inputClassName}
    />
  )
  return (
    <div className={className}>
      <Label htmlFor={id} className={labelClassName}>
        {label}
      </Label>
      {unit ? (
        <div className="flex items-center gap-2">
          {input}
          <span className="text-sm text-palette-jungleGreen500">{unit}</span>
        </div>
      ) : (
        input
      )}
      {hint && <p className="text-xs text-palette-jungleGreen500">{hint}</p>}
    </div>
  )
}

export default NumberField
